import { React } from "react";
import { Link } from 'react-router-dom';
import "./Navbar.css";
import cloud from "./cloud.jpg";
import user from "./user.png";
import Dropdown from 'react-bootstrap/Dropdown';

const Navbar = () => {
    return (
        <div className="Contaainer">
            <nav class=" vertical-nav nnavbar fixed-left navbar-light bg-dark">
                <div class="sidebar-header">
                    <h1 class="title"><img src={cloud}></img>Title Here</h1>
                    <div></div>
                </div>
                <ul class="list-unstyled components">
                    <Link to="/">
                        <li>
                            <h3 class="button"> Dashboard</h3>
                        </li>
                    </Link>
                    <Link to="/news">
                        <li>
                            <h3 class="button">News</h3>
                        </li>
                    </Link>
                    <Link to="/login">
                        <li>
                            <h3 class="button">Logout</h3>
                        </li>
                    </Link>
                </ul>
            </nav>
            <div>
                <nav class="navbar navbar-light bg-light justify-content-between">
                    <a class="navbar-brand">Navbar</a>
                    <form class="form-inline">
                        <Dropdown>
                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                Admin<img src={user}></img>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item href="#/action-1">Profile</Dropdown.Item>
                                <Dropdown.Item href="#/action-2">Edit Profile</Dropdown.Item>
                                <Link to="/login">
                                    <Dropdown.Item href="#/action-3">Log Out</Dropdown.Item>
                                </Link>
                            </Dropdown.Menu>
                        </Dropdown>
                    </form>
                </nav>
                <br></br>
            </div>    
        </div>
    );
};

export default Navbar;